export default class TrustindexPopupWidget {
	constructor(widget)
	{
		this.widget = widget;

		Trustindex.convertToDialog(this.widget.querySelector('.ti-popup-widget'));
	}

	click(event)
	{
		if (event.target.matches('a[data-subcontent]')) {
			event.preventDefault();

			let button = event.target;
			button.subcontentTarget = this.widget.querySelector(button.getAttribute('data-subcontent-target'));

			if (!button.subcontentTarget || button.classList.contains('ti-loading')) {
				return;
			}

			if (button.subcontentTarget.innerHTML.trim() !== "") {
				button.removeAttribute('data-subcontent');
				button.removeAttribute('data-subcontent-target');
			} else if (this.widget.pid) {
				return this.load(button);
			}
		}

		if (event.target.matches('a[href="#popup"]') || event.target.matches('a[href="#dropdown"]')) {
			event.preventDefault();
			this.togglePopup(event.target);
		}

		if (event.target.matches('.ti-popup-header .ti-close-lg')) {
			event.preventDefault();
			this.closePopup();
		}
	}

	documentClick(event)
	{
		// the lightbox is opened from the popup, so its clicks must not close the popup behind it
		if (typeof this.widget.popup !== 'undefined' && !event.target.closest('.ti-widget-container, .ti-widget-lightbox')) {
			event.preventDefault();
			this.closePopup();
		}
	}

	async load(button)
	{
		console.log('[Trustindex Widget: '+this.widget.pid+' - '+this.widget.layoutId+'] subcontent loading');

		button.classList.add('ti-loading');

		let url = Trustindex.getWidgetUrl(this.widget.pid)+'_subcontent-'+button.getAttribute('data-subcontent')+'.html';
		let html = await Trustindex.request(url);
		if (!html) {
			return false;
		}

		console.log('[Trustindex Widget: '+this.widget.pid+' - '+this.widget.layoutId+'] popup loaded');

		button.removeAttribute('data-subcontent');
		button.removeAttribute('data-subcontent-target');
		button.subcontentTarget.innerHTML = html;
		button.classList.remove('ti-loading');

		this.widget.TrustindexWidget.getSubclasses();
		this.widget.TrustindexWidget.formatInternationalNumbers();

		this.togglePopup(button);
	}

	getPopup()
	{
		return this.widget.querySelector('.ti-dropdown-widget, .ti-popup-widget');
	}

	isOpen()
	{
		let popup = this.getPopup();

		return !!popup && popup.classList.contains('active');
	}

	registerDialogEvents(dialog)
	{
		if (dialog.tiDialogEventsRegistered) {
			return;
		}

		dialog.tiDialogEventsRegistered = true;

		dialog.addEventListener('close', () => {
			if (!dialog.open) {
				this.closePopup();
			}
		});
	}

	togglePopup(button)
	{
		return this.isOpen() ? this.closePopup() : this.openPopup(button);
	}

	openPopup(button)
	{
		this.widget.button = button;
		this.widget.popup = this.getPopup();

		if (!this.widget.popup) {
			return delete this.widget.button;
		}

		this.widget.button.classList.add('active');
		this.widget.popup.classList.add('active');

		if ('DIALOG' === this.widget.popup.tagName && !this.widget.popup.open && this.widget.popup.isConnected) {
			this.registerDialogEvents(this.widget.popup);
			this.widget.popup.showModal();
		}

		if (!this.widget.popupFormatted) {
			this.widget.popupFormatted = true;
			this.widget.TrustindexWidget.format();
			this.widget.TrustindexWidget.callSubclassesMethods('resize');
		}
	}

	closePopup()
	{
		let button = this.widget.button;
		let popup = this.widget.popup;

		delete this.widget.button;
		delete this.widget.popup;

		if (button) {
			button.classList.remove('active');
		}

		if (!popup) {
			return;
		}

		popup.classList.remove('active');

		if ('DIALOG' === popup.tagName && popup.open) {
			popup.close();
		}

		if (button) {
			button.focus({ preventScroll: true });
		}
	}

	destroy()
	{
		let popup = this.getPopup();

		if (popup && 'DIALOG' === popup.tagName && popup.open) {
			popup.close();
		}
	}
};
